'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { Button, ButtonLink } from '@/components/ui/button'
import { Dialog, DialogActions, DialogBody, DialogTitle } from '@/components/ui/dialog'

/** The copy, resolved by the locale layout from `ui.integrationUnavailable` and `ui.actions.close`. */
export type IntegrationUnavailableCopy = {
  title: string
  body: string
  /** Label of the way out: the contact form, which depends on no third party. */
  contact: string
  contactHref: string
  close: string
}

/**
 * What a visitor sees when a third-party widget they asked for — the demo planner, the chat — did
 * not load. Without it the click simply did nothing, which reads as a broken button. Clicking again
 * retries (`loadExternalScript` drops the failed element); the contact form is the route that does
 * not depend on the third party at all.
 */
export function IntegrationUnavailableDialog({
  open,
  onClose,
  copy,
}: {
  open: boolean
  onClose: () => void
  copy: IntegrationUnavailableCopy
}) {
  return (
    <Dialog open={open} onClose={onClose} data-sentry-element="Dialog" data-sentry-component="IntegrationUnavailableDialog" data-sentry-source-file="integration-unavailable-dialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="integration-unavailable-dialog.tsx">{copy.title}</DialogTitle>
      <DialogBody data-sentry-element="DialogBody" data-sentry-source-file="integration-unavailable-dialog.tsx">
        <p className="text-sm/6 text-mist-700 dark:text-mist-300">{copy.body}</p>
      </DialogBody>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="integration-unavailable-dialog.tsx">
        <Button type="button" size="lg" color="light" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="integration-unavailable-dialog.tsx">
          {copy.close}
        </Button>
        <ButtonLink href={copy.contactHref} size="lg" color="dark/light" onClick={onClose} data-sentry-element="ButtonLink" data-sentry-source-file="integration-unavailable-dialog.tsx">
          {copy.contact}
        </ButtonLink>
      </DialogActions>
    </Dialog>
  )
}
